module.exports = __webpack_public_path__ + "media/images/pla/pla14-56a53eabcfb373a8d53e4b7bb964325e.jpg";